// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4582f6a8","453":"dbda97ce","455":"108d78ad","977":"f25848ca"}[chunkId] + ".chunk.js";
};